import React, {useState} from 'react';
import {observer} from "mobx-react";
import {useServices} from "../../../hooks/use-services.hook";
import {LoginFormModel} from "../../../services/user/models/login/login-form.model";
import {FormComponent} from "../../forms/form.component";
import {StringFieldEditorComponent} from "../../forms/string-field/string-field-editor.component";
import {PasswordFieldEditorComponent} from "../../forms/password/password-field-editor.component";
import {PrimaryButton} from "../../../basic-components/buttons/primary-button";
import styled from "styled-components";
import {DotsAnimationComponent} from "../../dots-animation/dots-animation.component";
import {BooleanFieldEditorComponent} from "../../forms/boolean-field/boolean-field-editor.component";
import {DotRezDomainCodes} from "../../../services/dot-rez-api/data-contracts/enums/domain-codes.enum";


const AgencyLoginFormBox = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: ${props => props.theme.spacing.flexGap12};
    flex-grow: 1;
`

const ErrorBox = styled.div`
    color: ${props => props.theme.colors.danger};
    font-size: ${props => props.theme.fontSize.body2};
`

const GreetingMessageBox = styled.div`
    font-size: ${props => props.theme.fontSize.h1};
    font-weight: ${props => props.theme.fontWeight.semiBold};
    color: ${props => props.theme.colors.primaryShade};
    line-height: 1.5;
`

const FormBox = styled(FormComponent)`
    width: min(650px, 100%);
`

const ForgotPasswordMessageBox = styled.div`
    color: ${props => props.theme.colors.notes};
    font-size: ${props => props.theme.fontSize.body2};
`

export const AgencyLoginFormComponent: React.FC = observer(() => {
    const services = useServices();

    const [hasError, setHasError] = useState(false);

    const [loginForm] = useState(new LoginFormModel(services, {
                                                    domain: DotRezDomainCodes.Agency,
                                                    getUserNameFieldLabel: () => services.language.translate('User name')
                                }));

    const fields = loginForm.fields;

    const onSubmit = async () => {
        if(loginForm.isLoginInProgress) {
            return;
        }

        setHasError(false);
        try {
            await loginForm.executeLogin()

        }
        catch (err) {
            setHasError(true);
            services.logger.error('Login failed', err);
        }
    }

    const renderError = () => {
        if(!hasError) {
            return null;
        }

        return (
            <ErrorBox>
                {services.language.translate('Invalid user name or password.')}
            </ErrorBox>
        )
    }

    const renderButtonContent = () => {
        if(loginForm.isLoginInProgress) {
            return (
                <DotsAnimationComponent/>
            )
        } else {
            return (
                <span>
                    {services.language.translate('Login')}
                </span>
            )
        }
    }

    return (
        <AgencyLoginFormBox>
            <GreetingMessageBox>
                {services.language.translate(`Welcome to Aeroitalia's agency portal`)}
            </GreetingMessageBox>
            <FormBox>

                <StringFieldEditorComponent field={fields.userName}/>
                <PasswordFieldEditorComponent field={fields.password}/>
                <BooleanFieldEditorComponent field={fields.rememberMe} />
                {renderError()}
                <PrimaryButton onClick={onSubmit} fullWidth={true}>
                    {renderButtonContent()}
                </PrimaryButton>

                <ForgotPasswordMessageBox>
                    {services.language.translate(`If you don't have an user or you don't remember your password, please contact your account manager or our call center.`)}
                </ForgotPasswordMessageBox>

            </FormBox>
        </AgencyLoginFormBox>
    )
})